import React from "react";
import { Card, CardBody, Image, Text, VStack } from "@chakra-ui/react";

import { ClickableComponentModal } from "@components";
import { ModuleImage } from "@constants";

type ExcludeKey<M extends object, T> = { [key in Exclude<keyof M, T>]: M[key] };
type ImagePopUpProps = ExcludeKey<ModuleImage, "timestamp">;

export function ImagePopUp({ src, title, comments }: ImagePopUpProps) {
  const imageAlt = `Image of module: ${title}`;
  return (
    <ClickableComponentModal
      ClickableComponent={({ ...delegated }) => (
        <Card {...delegated}>
          <CardBody as={VStack} alignItems="center" justifyContent="center">
            <Image boxSize="100px" src={src} alt={imageAlt} fit="cover" />
          </CardBody>
        </Card>
      )}
      title={title}
    >
      <Image src={src} alt={imageAlt} boxSize="auto" maxHeight="70vh" />
      <Text margin="8px">{comments}</Text>
    </ClickableComponentModal>
  );
}
